"use client";
import { cn as l } from "../../../lib/utils.es.js";
import { jsx as t } from "react/jsx-runtime";
import * as o from "@radix-ui/react-label";
function b({ className: e, ...i }) {
  return /* @__PURE__ */ t(o.Root, {
    className: l("lib:flex lib:select-none lib:items-center lib:gap-2 lib:font-normal lib:leading-none! lib:peer-disabled:cursor-not-allowed lib:peer-disabled:opacity-50 lib:group-data-[disabled=true]:pointer-events-none lib:group-data-[disabled=true]:opacity-50", "lib:text-medium-sm lib:md:text-medium-md", e),
    "data-slot": "label",
    ...i
  });
}
export {
  b as BaseLabel
};
